/* eslint-disable arrow-parens */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Badge,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Button, 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from 'reactstrap';
import { RTLProps } from '@/shared/prop-types/ReducerProps';
import { useQuery } from 'react-query';
import axios from 'axios';
import { useCookies } from 'react-cookie';

const Consignee = ({ rtl }) => {
  const { t } = useTranslation('common');
  const [cookies, setCookie] = useCookies(['tranAuthToken']);
  const [modal, setModal] = useState(false);
  const [emailToBeDeleted, setemailToBeDeleted] = useState('');
  const toggle = () => setModal(!modal);

  const
    {
      data,
      isLoading,
      isFetching,
      isError,
    } = useQuery('todos', () => axios.get('https://orca-app-5i5qx.ondigitalocean.app/api/admin/consignee/list', {
      headers: {
        Authorization: `Bearer ${cookies.tranAuthToken}`,
      },
    }));
  if (data && !isLoading && !isFetching && !isError) {
    console.log('consignee', data.data);
  }



  function gettingEmailForDeleting(emaila) {
    setemailToBeDeleted(emaila);
  }

  async function deletingUser(email) { 
    const emailData = JSON.stringify({
      email: `${email}`,
    });
  
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://orca-app-5i5qx.ondigitalocean.app/api/admin/delete/user',
      headers: { 
        Authorization: `Bearer ${cookies.tranAuthToken}`, 
        'Content-Type': 'application/json',
      },
      data: emailData,
    };

    await axios(config).then(response => console.log(response.data)).catch((error) => console.log(error));
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">All Consignee</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">All Consignee Table</h5>
              </div>
              <Table responsive hover className="table--bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>User Name</th>
                    <th>Admin Name</th>
                    <th>Company Name </th>
                    <th>Address</th>
                    <th>Consignor</th>
                    <th>Contact</th>
                    <th>District</th>
                    <th>Email</th>
                    {/* <th>GST No.</th> */}
                    <th>Location</th>
                    <th>Manager name</th>
                    {/* <th>PAN number</th> */}
                    <th>Pin Code </th>
                    <th>State</th>
                    <th>Time</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching && <tr><td>Loading...</td></tr>}
                  {!isLoading && !isFetching && !isError && data && data.data && data.data.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.userName}</td>
                      <td>{item.adminName}</td>
                      <td>{item.companyName}</td>
                      <td>{item.address}</td>
                      <td>{item.consignor}</td>
                      <td>{item.contact}</td>
                      <td>{item.district}</td>
                      <td>{item.email}</td>
                      {/* <td>{item.gstNumber}</td> */}
                      <td>{item.location}</td>
                      <td>{item.managerName}</td>
                      {/* <td>{item.panNumber}</td> */}
                      <td>{item.pincode}</td>
                      <td>{item.state}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                      {/* <td><Badge color={item.status_resp}>{item.badge_resp}</Badge></td> */}
                      <td>{item.status ? <p style={{ fontWeight: 'bold' }}>True</p> : <p style={{ fontWeight: 'bold' }}>False</p>}</td>
                      <td>{item.status ? <Badge onClick={() => { gettingEmailForDeleting(item.email); toggle(); }} color="danger" size="sm">Delete</Badge> : <Badge disabled color="secondary" size="sm">Delete</Badge>}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>User Deletion</ModalHeader>
        <ModalBody> 
          Do you want to delete {emailToBeDeleted}?
        </ModalBody>
        <ModalFooter cssModule={{ justifyContent: 'center' }}>
          <Button color="primary" onClick={() => { deletingUser(emailToBeDeleted); toggle(); }}>
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

Consignee.propTypes = {
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(Consignee);
